




















import type { PropType } from "vue"
import type { stadium_curator } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import TsUpload from "@/components/upload.vue";

export default Vue.extend({
  name      : "StadiumCurator",
  components: { TsUpload },
  props     : {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    form    : { type: Object as PropType<stadium_curator> },
  },
  data() {
    return {
      area    : [] as string[],
      city    : [] as string[],
      options : [
        // { label: '未知', value: '0' },
        { label: '男', value: '1' },
        { label: '女', value: '2' },
      ],
    }
  },
  methods: {
    change_avatar(p: string) {
      this.form.manager_avatar = p
    },
    submit() {
      const params = this.$deep_copy(this.form)
      params.estimate_id = this.id
      this.$emit("save", params)
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    }
  }
})
